import { Box, Divider, Typography } from '@mui/material';
import { useField } from 'formik';
import { TransactionPricingOfferPayload } from 'types/graphql';

import { useTransactionData } from 'src/hooks/useTransactionCharges';

import { CustomGridInput } from './components';
import { GridHeader } from './GridHeader';

interface AdditionalChargesProps {
    name: string;
    serviceType: string;
    selectedTransactionOffer: TransactionPricingOfferPayload;
}

export const AdditionalCharges: React.FC<AdditionalChargesProps> = ({ name, serviceType }) => {
    const [{ value }] = useField(name);
    const { ADDITIONAL_CHARGES, ONLINE_ADDITIONAL_CHARGES } = useTransactionData();

    return (
        <Box>
            <Typography fontSize="24px" color="#434341" marginBottom="4px">
                Additional Charges Table
            </Typography>
            <Typography fontSize="14px" color="#666666" marginBottom="8px">
                Additional Transaction charge for nature of payments capture
            </Typography>

            <Divider
                sx={{
                    borderColor: 'warning.main',
                    marginBottom: '34px',
                }}
            />
            <GridHeader additionalCharges />
            {Object.keys(value).map((key) => {
                const label =
                    serviceType === 'ONLINE'
                        ? ONLINE_ADDITIONAL_CHARGES.find((el) => el.name === key).label
                        : ADDITIONAL_CHARGES.find((el) => el.name === key).label;

                return (
                    <CustomGridInput
                        key={key}
                        name={`${name}.${key}`}
                        componentType="additional-tariffs"
                        charge={{ label }}
                    />
                );
            })}
        </Box>
    );
};
